window.SocialReferralAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.SocialReferralServers);


    self.getReferralLists = function (params) {

        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'users/referral_lists', 'GET', params)
            .then(function (res) {
                if (res && res.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.getListUsers = function (listId, params) {

        var deferred = $q.defer();

        _protected.request('users/referral_lists/' + listId, 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteListUser = function (listId, urlParams, userId) {
        var deferred = $q.defer();


        var url = 'users/referral_lists/' + listId + '/members/' + urlParams;

        if (userId) {
            url += '/' + userId;
        }

        _protected.request(url, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data === "SUCCESS") {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;

    };


    self.deleteList = function (listId) {
        var deferred = $q.defer();

        _protected.request('users/referral_lists/' + listId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data === "SUCCESS") {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getExternalReferrals = function (params) {
        var deferred = $q.defer();

        _protected.request('users/external_referrals', 'GET', params)
            .then(function (res) {
                if (res && res.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.deleteExternalReferral = function (id) {
        var deferred = $q.defer();

        _protected.request('users/external_referrals/' + id, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data === "SUCCESS") {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.addExternalReferral = function (params) {
        var deferred = $q.defer();
        _protected.request('users/external_referrals', 'POST', params)
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(null);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editExternalReferral = function (id, params) {
        var deferred = $q.defer();

        _protected.request('users/external_referrals/' + id, 'PUT', params)
            .then(function (res) {
                if (res && res.data && res.data.data === "SUCCESS") {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.referralsSend = function (params) {
        var deferred = $q.defer();

        _protected.request('jobs/referrals/send', 'POST', params)
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.createList = function (params) {
        var deferred = $q.defer();

        _protected.request('users/referral_lists', 'POST', params).then(function (res) {
            if (res && res.status === 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }
        }, function (res) {
            deferred.reject(res);
        });

        return deferred.promise;
    };
    self.editList = function (id, params) {
        var deferred = $q.defer();

        _protected.request('users/referral_lists/' + id, 'PUT', params).then(function (res) {
            if (res && res.data && res.data.data === "SUCCESS") {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }
        }, function (res) {
            deferred.reject(res);
        });

        return deferred.promise;
    };

    self.getBrandJobsApplicationSources = function(brandId, jobId, appId){
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/applications/'+appId, 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getSocialRefferalSettings = function(brandIds) {
        let deferred = $q.defer();
        let params = {
            brands_ids: Array.isArray(brandIds) ? brandIds : [brandIds]
        }

        _protected.request('brands/settings', 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getSocialReferralUserSettings = function(){
        var deferred = $q.defer();

        _protected.request('brands/users/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getSocialReferralInvitation = function(jobId, token) {
        var deferred = $q.defer();

        _protected.request('jobs/' + jobId + '/referrals/invite?token=' + encodeURIComponent(token), 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getSocialListSharedBrands = function (listId) {
        var deferred = $q.defer();
        _protected.request('users/referral_lists/' + listId + '/brands', 'GET').then(function (res) {
            if (res && res.status === 200 && res.data && res.data.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }
        }, function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    };

    self.shareReferralList = function (listId, payload) {
        var deferred = $q.defer();

        _protected.request('users/referral_lists/' + listId + '/brands', 'PUT', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };

    self.unsubscribeJobSocialReferral = function (token) {
        var deferred = $q.defer();

        var payload = {
            token : decodeURIComponent(token)
        };

        _protected.request('jobs/referrals/unsubscribe', 'POST', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(null);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeeReferralSettings = function () {

        var deferred = $q.defer();

        _protected.request('users/notifications/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.editEmployeeReferralSettings = function (employeeReferralSettings) {

        var deferred = $q.defer();

        var payload = {
            opt_out_settings: employeeReferralSettings
        };

        _protected.request('users/notifications/settings', 'PUT', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(null);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getDynamicListFilters = function (listId) {
        var deferred = $q.defer();

        _protected.request('users/referral_lists/'+listId, 'GET')
            .then(function (res) {
                if (res && res.status === 200 && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(null);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.hasJobReferral = function () {
        var deferred = $q.defer();

        _protected.request('users/referrals/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    }

    self.checkDuplicateSource = function (params) {
        var deferred = $q.defer();

        _protected.request('users/external_referrals/check', 'POST', params).then(function (res) {
            if (res && res.data && res.data.data && res.status === 200) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res);
            }

        }).catch(function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };
};
